// any added here need to appear within `ts/elements/ElementFunction.type.ts`
export const ATTRIBUTE_CALLABLE_DEFS = [
    ['alt', 'alt'],
    ['ariaLabel', 'aria-label'],
    ['referrerPolicy', 'referrerpolicy'],
    ['autoFocus', 'autoFocus'],
    ['border', 'border'],
    ['id', 'id'],
    ['for', 'for'],
    ['fill', 'fill'],
    ['content', 'content'],
    ['charset', 'charset'],
    ['cellPadding', 'cellpadding'],
    ['cellSpacing', 'cellspacing'],
    ['class', 'class'],
    ['href', 'href'],
    ['lang', 'lang'],
    ['label', 'label'],
    ['loading', 'loading'],
    ['value', 'value'],
    ['placeholder', 'placeholder'],
    ['src', 'src'],
    ['title', 'title'],
    ['width', 'width'],
    ['height', 'height'],
    ['type', 'type'],
    ['min', 'min'],
    ['max', 'max'],
    ['step', 'step'],
    ['name', 'name'],
    ['wrap', 'wrap'],
    ['checked', 'checked'],
    ['disabled', 'disabled'],
    ['selected', 'selected'],
    ['minLength', 'minLength'],
    ['maxLength', 'maxLength'],
    ['inputMode', 'inputMode'],
    ['open', 'open'],
    ['rel', 'rel'],
    ['required', 'required'],
    ['readonly', 'readonly'],
    ['readOnly', 'readonly'],
    ['rows', 'rows'],
    ['style', 'style'],
    ['target', 'target'],
    ['viewBox', 'viewBox'],
    ['valign', 'valign'],
];
